var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed"},[_c('div',{staticClass:"shadow bg-white center ptb-5 border-radius",on:{"click":_vm.goTop}},[_c('img',{attrs:{"src":require("../assets/fixed/fixed_3.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }